import { FeApi } from '../..';
import type { Site } from '../../domain/entities/site';

import { siteOperationalPhaseMapper } from './site-operational-phase.mapper';
import { siteUnitStatusMapper } from './site-unit-status.mapper';

export function siteMapper(data: FeApi.GetSiteDetailV2ViewOutput): Site {
  return {
    id: data.accure_id,
    fullFrontendId: data.full_frontend_id,
    name: data.name ?? '',
    pictureUrl: data.picture ?? undefined,
    address: data.address ?? '',
    latitude: data.latitude ?? undefined,
    longitude: data.longitude ?? undefined,
    installationDate: data.installation_date
      ? new Date(data.installation_date)
      : undefined,
    commissioningDate: data.commissioning_date
      ? new Date(data.commissioning_date)
      : undefined,

    operationalPhase: siteOperationalPhaseMapper(data.operational_phase),

    nominalPowerW: data.nominal_power_w ?? undefined,
    nominalEnergyWH: data.nominal_energy_wh ?? undefined,
    cellType: data.cell_type ?? undefined,
    alerts: {
      critical: data.alerts?.critical ?? 0,
      warning: data.alerts?.warning ?? 0,
    },
    nbOpenTasks: data.open_cards_count ?? 0,
    unitStatus: siteUnitStatusMapper(data.unit_status),
  };
}
